<section class="content">

  <div class="row" style="margin-top: 8%;">
      <div class="col-md-12 text-center">
          
          <div style="margin-bottom: 10px;"><img src="./assets/images/error_404.png" /></div>
          <p style="font-size: 1.2em; color:#808080">A página solicitada não foi encontrada</p>
          <br />
          <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/home64.png" /></a>
          <p style="color: #808080;">Página Inicial</p>
      </div>


  </div>

</section>